/// <reference path="Utilities/_reference.ts" />

module YVR.OperationalSnapshot {
	// Dependencies
	import logger = YVR.Utilities.Logger;
	import i18n = YVR.Utilities.I18n;

	//Ops live data interface
	interface IOpsLive {
		daily_forecasted_passengers?: string;
		total_flights?: string;
		arrivals_otp?: string;
		departures_otp?: string;
	}

	//Ops live Collection Interface
	interface IOpsLiveCollection {
		value: IOpsLive[];
	}

	//cache parkade data
	let opsLiveCache: IOpsLive[] = [];

	interface ICatsaWait {
		WaitTime?: string;
		Terminal?: string;
	}

	//Ops live Collection Interface
	interface ICatsaWaitCollection {
		value: ICatsaWait[];
	}

	//cache parkade data
	let catsaWaitCache: ICatsaWait[] = [];

	// outbound baggage data
	interface IOutboundBag {
		outbound_bag_delivery_performance?: string;
	}
	// outbound baggage collection
	interface IOutboundBagCollection {
		value: IOutboundBag[];
	}
	// outboundBag local cache
	let outboundBagCache: IOutboundBag[] = [];

	// New!
	// Start Winter Ops

	interface ITemperature {
		Unit?: string;
		Value?: Number;
	}

	interface IWinterOps {
		Timestamp?: string;
		Description?: string;
		Temperature?: ITemperature;
		IsAircraftDeicingActive?: boolean;
		IsSnowRemovalActive?: boolean;
		VisibilityOperations?: Number;
		SnowRemovalActivity?: string;
		RequestUrl?: string;
	}

	interface IWinterOpsCollection {
		value: IWinterOps[];
	}

	let winterOpsCache: IWinterOps[] = [];
	// End Winter Ops

	let options;
	options = {
		//uncomment below for prod/staging
		opsLiveServiceUrl: '/_api/OpsLive',
		catsaWaitServiceUrl: '/_api/CatsaWait',
		outboundBagServiceUrl: '/_api/OutboundBag',
		winterOpsServiceUrl: '/_api/WinterOps'
	};

	// CSS Classes
	const classes = {
		num: 'availability-number'
	};

	// Cached jQuery elements
	const elements = {
		operationalSnapshotWidget: $('.operational-snapshot')
	};

	//main function
	function main() {
		if (elements.operationalSnapshotWidget.length > 0) {
			getOpsLive();
			getCatsaWait();
			getOutboundBag();
			getWinterOps();
		}
	}

	//////////////////// Ops Live Functions
	function getOpsLive() {
		//console.log('get ops live');
		if (elements.operationalSnapshotWidget.length) {
			callOpsLiveApi()
				.then(renderOpsLiveData)
				.fail(() => {
					logger.error('[parkade-data][getParkadeInfo] An error occured retrieving the parkade data.');
					console.log('failed to get parkade data');
					//show error message here
				});
		}
	}

	function renderOpsLiveData(data: IOpsLiveCollection) {
		if (data && data.value && data.value.length) {
			//console.log('rendering ops live');
			opsLiveCache = data.value;

			//console.log(opsLiveCache);


			//there's only one array
			let opsLive = opsLiveCache[0];

			//get daily passengers
			let dailyPassengers = Number(opsLive['daily_forecasted_passengers']).toLocaleString();
			//console.log(dailyPassengers);

			//get number of flights
			let numFlights = opsLive['total_flights'];

			//combine OTP
			let arrivalsOTP = opsLive['arrivals_otp'];
			arrivalsOTP = arrivalsOTP.slice(0, -1);

			let departuresOTP = opsLive['departures_otp'];
			departuresOTP = departuresOTP.slice(0, -1);

			let otp = Number(departuresOTP) + Number(arrivalsOTP);
			otp = otp / 2;
			otp = otp.toFixed(2) + '%';


			$('#daily-passengers').html(dailyPassengers);
			$('#num-flights').html(numFlights);
			$('#on-time-performance').html(opsLive['departures_otp']);

			return true;
		}
	}

	// calls API for parkade info. API is on Fishtank side
	function callOpsLiveApi(): JQueryPromise<IOpsLiveCollection> {
		return $.get({
			url: options.opsLiveServiceUrl,
			success() {
				logger.log('Successfully retrieved ops live data.');
			}
		});
	}

	//////////////////// Catsa Wait
	function getCatsaWait() {
		//console.log('get catsa wait');
		if (elements.operationalSnapshotWidget.length) {
			callCatsaWaitApi()
				.then(renderCatsaWaitData)
				.fail(() => {
					logger.error('[parkade-data][getParkadeInfo] An error occured retrieving the parkade data.');
					console.log('failed to get parkade data');
					//show error message here
				});
		}
	}

	function renderCatsaWaitData(data: ICatsaWaitCollection) {
		if (data && data.value && data.value.length) {
			//console.log('rendering catsa wait');
			catsaWaitCache = data.value;

			//console.log(catsaWaitCache);


			let domesticWait = $.grep(catsaWaitCache, function (node) {
				return node.Terminal === 'Domestic South';
			});

			let internationalWait = $.grep(catsaWaitCache, function (node) {
				return node.Terminal === 'International';
			});

			let usWait = $.grep(catsaWaitCache, function (node) {
				return node.Terminal === 'Transborder';
			});


			if (domesticWait.length) {
				let domestic = domesticWait[0];
				let seconds = Math.trunc(Number(domestic['WaitTime']) / 60);
				$('#catsa-domestic').html(seconds);
			}

			if (internationalWait.length) {
				let int = internationalWait[0];
				let seconds = Math.trunc(Number(int['WaitTime']) / 60);
				$('#catsa-international').html(seconds);
			}

			if (usWait.length) {
				let us = usWait[0];
				let seconds = Math.trunc(Number(us['WaitTime']) / 60);
				$('#catsa-us').html(seconds);
			}

			return true;
		}
	}

	// calls API for parkade info. API is on Fishtank side
	function callCatsaWaitApi(): JQueryPromise<ICatsaWaitCollection> {
		return $.get({
			url: options.catsaWaitServiceUrl,
			success() {
				logger.log('Successfully retrieved ops live data.');
			}
		});
	}

	/////////////////API  for outbound bag

	function getOutboundBag() {
		if (elements.operationalSnapshotWidget.length) {
			callOutboundBagApi()
				.then(renderOutboundBagData)
				.fail(() => {
					logger.error('[outboundBag][getOutboundBag] An error occured retrieving the parkade data.');
					console.log('failed to get outbound bag data data');
					//show error message here
				});
		}
	}

	function renderOutboundBagData(data: IOutboundBagCollection) {
		if (data && data.value && data.value.length) {
			outboundBagCache = data.value;

			//there's only one array
			let outboundBag = outboundBagCache[0];

			$('#outbound-bag').html(outboundBag['outbound_bag_delivery_performance']);

			return true;
		}
	}

	// calls API for parkade info. API is on Fishtank side
	function callOutboundBagApi(): JQueryPromise<IOutboundBagCollection> {
		return $.get({
			url: options.outboundBagServiceUrl,
			success() {
				logger.log('Successfully retrieved ops live data.');
			}
		});
	}

	//////////////////////////////// API for winter ops
	function getWinterOps() {
		if (elements.operationalSnapshotWidget.length) {
			callWinterOpsApi()
				.then(renderWinterOpsData)
				.fail(() => {
					logger.error('[winterOps][getWinterOps] An error occured retrieving the winter ops data.');
					console.log('failed to get winter ops  data');
					//show error message here
				});
		}
	}

	function renderWinterOpsData(data: IWinterOpsCollection) {
		if (data && data.value && data.value.length) {
			winterOpsCache = data.value;

			renderWeather();
			renderAirfield();

			return true;
		}
	}

	// calls API for parkade info. API is on Fishtank side
	function callWinterOpsApi(): JQueryPromise<IWinterOpsCollection> {
		return $.get({
			url: options.winterOpsServiceUrl,
			success() {
				logger.log('Successfully retrieved winter ops data.');
			}
		});
	}

	function renderWeather() {
		let weatherGrep = $.grep(winterOpsCache, function (node) {
			return node.RequestUrl.includes('weather');// 'https://yvrapi.azure-api.net/prod/weather/Latest';
		});

		let weather = weatherGrep[0];

		// Convert to Celsius if Unit is 2 (Fahrenheit)
		if (weather.Temperature.Unit === '2') {
			weather.Temperature.Value = (weather.Temperature.Value - 32) * 5 / 9;
		}

		weather.Temperature.Value = weather.Temperature.Value.toFixed(0);

		$('#winter-ops-temperature').html(weather.Temperature.Value);

		// Weather Description
		let weatherDescription = weather.Description;

		$('#winter-ops-weather-description').html(weatherDescription);

		weatherDescription = weatherDescription.toLowerCase();

		// Change Weather Image
		let imgTag = '<img src="/-/media/yvr/operational-snapshot/icons/weather/<image>.png">';

		const imgClass = $('#winter-ops-weather-description').closest('.content').prev('.image');


		if (weatherDescription.includes('rain') || weatherDescription.includes('showers') || weatherDescription.includes('drizzle')) {
			imgTag = imgTag.replace('<image>', 'rain');
			imgClass.empty().append(imgTag);
		}
		else if (weatherDescription.includes('snow') || weatherDescription.includes('flurries') || weatherDescription.includes('sleet')) {
			imgTag = imgTag.replace('<image>', 'snow');
			imgClass.empty().append(imgTag);
		}
		else if (weatherDescription.includes('fog') || weatherDescription.includes('haze')) {
			imgTag = imgTag.replace('<image>', 'fog');
			imgClass.empty().append(imgTag);
		}
		else if (weatherDescription.includes('storm')) {
			imgTag = imgTag.replace('<image>', 'thunderstorm');
			imgClass.empty().append(imgTag);
		}
		if (weatherDescription.includes('cloudy')) {
			imgTag = imgTag.replace('<image>', 'cloudy');
			imgClass.empty().append(imgTag);
		}
		else {
			imgTag = imgTag.replace('<image>', 'sunny');
			imgClass.empty().append(imgTag);
		}
	}

	function renderAirfield() {
		let airfieldMetricsGrep = $.grep(winterOpsCache, function (node) {
			return node.RequestUrl.includes('AirfieldStateMetrics');// 'https://yvrapi.azure-api.net/prod/weather/Latest';
		});

		let airfieldMetrics = airfieldMetricsGrep[0];

		// if(airfieldMetrics.IsSnowRemovalActive){
		//     let airfieldUsagesGrep = $.grep(winterOpsCache, function (node) {
		//         return node.RequestUrl.includes('AirfieldUsage');// 'https://yvrapi.azure-api.net/prod/weather/Latest';
		//     });

		//     let airfieldUsages = airfieldUsagesGrep[0];

		//     console.log(airfieldUsages);
		//     console.log(airfieldUsages.SnowRemovalActivity);

		// }

		// Visibility Operations
		let visibilityOperations = airfieldMetrics.VisibilityOperations;
		if (visibilityOperations === 1) {
			$('#winter-ops-visibility').html('Normal');
		}
		else if (visibilityOperations === 2) {
			$('#winter-ops-visibility').html('Reduced');
		}
		else if (visibilityOperations === 3) {
			$('#winter-ops-visibility').html('Low');
		}
		else if (visibilityOperations === 4) {
			$('#winter-ops-visibility').html('Restricted');
		}
		else {
			$('#winter-ops-visibility').html('Unknown');
		}

		// Airplane Deicing
		if (airfieldMetrics.IsAircraftDeicingActive) {
			$('#winter-ops-deicing').html('Active');
			$('#winter-ops-deicing').addClass('text-success');
			$('#winter-ops-deicing').removeClass('font-yvr-blue');
		}
		else {
			$('#winter-ops-deicing').html('Inactive');
			$('#winter-ops-deicing').addClass('text-danger');
			$('#winter-ops-deicing').removeClass('font-yvr-blue');
		}


		// Snow Removal Activity
		if (airfieldMetrics.IsSnowRemovalActive) {
			$('#winter-ops-snow-removal').html('Active');
			$('#winter-ops-snow-removal').addClass('text-success');
			$('#winter-ops-snow-removal').removeClass('font-yvr-blue');
		}
		else {
			$('#winter-ops-snow-removal').html('Inactive');
			$('#winter-ops-snow-removal').addClass('text-danger');
			$('#winter-ops-snow-removal').removeClass('font-yvr-blue');
		}
	}


	main();
}
